import AxiosAPI from "./AxiosAPI";

export const fetchSubCategory = async () => {
  try {
    const response = await AxiosAPI.get(`/catalog/subcategories`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deleteSubCategoryDataApi = async (deleteSubCategoryId) => {
  try {
    const response = await AxiosAPI.delete(
      `/catalog/subcategories/${deleteSubCategoryId}`
    );
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const handleEditSubCategory = async (
  subCategoryData
) => {
  try {
    const response = await AxiosAPI.put(
      `/catalog/subcategories/${subCategoryData.key}`,
      subCategoryData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const handleAddSubCategory = async (subCategoryData) => {
  try {
    const response = await AxiosAPI.post(
      "/catalog/subcategories",
      subCategoryData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
